<template>
  <div>Terminals List</div>
</template>

<script>
export default {
  name: "Terminals",
  data() {
    return {
      loading: false
    };
  }
};
</script>